import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_6 = {
  class: "modal",
  style: {"width":"1020px"}
}
const _hoisted_7 = { class: "modal__content pa-1" }
const _hoisted_8 = { class: "stepper--bar" }
const _hoisted_9 = { class: "stepper--bar__header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__header--title-count",
  style: {"border":"1px solid white"}
}, "1", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__header--title",
  style: {"font-size":"80%"}
}, "Select Fields", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__header--title-count",
  style: {"border":"1px solid white"}
}, "2", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__header--title",
  style: {"font-size":"80%"}
}, "Project & Frequency", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__header--title-count",
  style: {"border":"1px solid white"}
}, "3", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__header--title",
  style: {"font-size":"80%"}
}, "Summary", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__header--title-count",
  style: {"border":"1px solid white"}
}, "3", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__header--title",
  style: {"font-size":"80%"}
}, "Submit", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "stepper--bar__content" }
const _hoisted_23 = { class: "pa--y-1 pa--left-1" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text--style-italic" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Select Data Fields"),
  /*#__PURE__*/_createElementVNode("span", { class: "text--style-italic" })
], -1)
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", {
  class: "text--style-italic",
  style: {"font-size":"80%"}
}, null, -1)
const _hoisted_29 = { class: "form-checkbox" }
const _hoisted_30 = ["id", "onClick"]
const _hoisted_31 = ["for"]
const _hoisted_32 = {
  key: 0,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_33 = {
  key: 1,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"100%","height":"0"} }, null, -1)
const _hoisted_35 = { style: {"width":"100%"} }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h4", { style: {"display":"inline-block"} }, "Premium Data", -1)
const _hoisted_37 = {
  key: 0,
  class: "form-checkbox",
  style: {"display":"inline-block","min-width":"0","margin-left":"10px"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  style: {"font-size":"small","color":"gray"},
  for: "selectAllFields"
}, "Select All", -1)
const _hoisted_39 = {
  key: 0,
  class: "pa--x-0 pa--bottom-1 col-3"
}
const _hoisted_40 = { class: "form-checkbox" }
const _hoisted_41 = ["id", "checked", "onClick", "disabled"]
const _hoisted_42 = ["for"]
const _hoisted_43 = {
  key: 0,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_44 = {
  key: 1,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_45 = {
  key: 2,
  class: "stepper--bar__content--label__info--error"
}
const _hoisted_46 = { class: "pa--y-1 pa--left-1" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "text--style-italic" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Select Project & Frequency"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text--style-italic",
    style: {"font-size":"80%"}
  })
], -1)
const _hoisted_50 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_51 = { class: "form-field__outline--control" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("b", null, "Select Project :- ", -1)
const _hoisted_53 = ["value", "disabled"]
const _hoisted_54 = { class: "dropdown display--flex justify--flex-end" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-filter btn--icon__prefix" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Filter", -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-3" }
const _hoisted_60 = { class: "form-field__checkboxlist" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("h4", null, "By State", -1)
const _hoisted_62 = ["onUpdate:modelValue", "onChange", "id"]
const _hoisted_63 = ["for"]
const _hoisted_64 = { class: "col-3" }
const _hoisted_65 = { class: "form-field__checkboxlist" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("h4", null, "By Zipcode", -1)
const _hoisted_67 = ["onUpdate:modelValue", "id"]
const _hoisted_68 = ["for"]
const _hoisted_69 = { class: "form--field__textarea ma--bottom-1" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("h4", null, "Google search keywords", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, null, -1)
const _hoisted_72 = { style: {"text-align":"right"} }
const _hoisted_73 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_74 = { class: "form-field__outline--control" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("b", null, "Frequency:- ", -1)
const _hoisted_76 = ["value"]
const _hoisted_77 = {
  key: 1,
  class: "form-field form-field__outline ma--x-1"
}
const _hoisted_78 = { class: "form-field__outline--control" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("b", null, "Month Of Year:- ", -1)
const _hoisted_80 = ["value"]
const _hoisted_81 = {
  key: 2,
  class: "form-field form-field__outline ma--x-1"
}
const _hoisted_82 = { class: "form-field__outline--control" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("b", null, "Day Of Month:- ", -1)
const _hoisted_84 = ["value"]
const _hoisted_85 = {
  key: 3,
  class: "form-field form-field__outline ma--x-1"
}
const _hoisted_86 = { class: "form-field__outline--control" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("b", null, "Day Of The Week:- ", -1)
const _hoisted_88 = ["value"]
const _hoisted_89 = { class: "form-field form-field__outline ma--x-1" }
const _hoisted_90 = { class: "form-field__outline--control" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("b", null, "Time Of Day:- ", -1)
const _hoisted_92 = ["value"]
const _hoisted_93 = { class: "form-field form-field__outline--control ma--x-1" }
const _hoisted_94 = {
  key: 0,
  class: "form-checkbox"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", {
  style: {"font-size":"small","color":"gray"},
  for: "selectAllFields"
}, "All Available Leads", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}, "   (When you select all available leads. We will process all available leads each day based on your frequency.) ", -1)
const _hoisted_97 = { class: "form-field form-field__outline--active ma--x-1" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("label", {
  for: "customLeadNumberId",
  class: "form-field__outline--control__label"
}, "Custom Leads", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", {
  for: "start-date",
  class: "form-field__outline--control__label"
}, "Email Addreses", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}, [
  /*#__PURE__*/_createTextVNode("   "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("To add additional recipients please add each email address seperated by comma (,) ")
], -1)
const _hoisted_101 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_102 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_103 = { class: "stepper--bar__content" }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("span", { class: "text--style-italic" }, null, -1)
const _hoisted_106 = { class: "stepper--bar__content--label__info" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "stepper--bar__content--label__info--message pa-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Auto Data Selected"),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__content--label__info--message__data" }, "Selected Fields ")
], -1)
const _hoisted_108 = { class: "row stepper--bar__content--label__info--message justify--flex-start pa-1" }
const _hoisted_109 = {
  key: 0,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_110 = {
  key: 1,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_111 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_112 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_113 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_114 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_115 = { class: "row stepper--bar__content--label__info--message justify--flex-start pa-1" }
const _hoisted_116 = {
  key: 0,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_117 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_118 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_119 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_120 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_121 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_122 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_123 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"80%"} }, "(System will send fresh Leads based on website traffic)", -1)
const _hoisted_125 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_126 = {
  key: 0,
  class: "stepper--bar__content--label__info--error pa-1",
  style: {"font-size":"80%"}
}
const _hoisted_127 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_128 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_129 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_130 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_131 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_132 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_133 = {
  key: 1,
  class: "stepper--bar__content--label__info--message pa-1"
}
const _hoisted_134 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_135 = {
  key: 2,
  class: "stepper--bar__content--label__info--message pa-1"
}
const _hoisted_136 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_137 = {
  key: 3,
  class: "stepper--bar__content--label__info--message pa-1"
}
const _hoisted_138 = {
  class: "stepper--bar__content--label__info--message__data",
  style: {"font-size":"14px"}
}
const _hoisted_139 = { class: "modal__footer" }
const _hoisted_140 = {
  key: 0,
  class: "stepper--bar__content--label__info--error ma--x-5"
}
const _hoisted_141 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!
  const _directive_outline = _resolveDirective("outline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 1,
                })
              }, _hoisted_12, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 2,
                })
              }, _hoisted_15, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 3,
                })
              }, _hoisted_18, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 4,
                })
              }, _hoisted_21, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-1", {
                'label--active': _ctx.stepper == 1,
              }])
            }, [
              _createElementVNode("div", _hoisted_23, [
                (this.isEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("h3", null, [
                        _createTextVNode("Editing Auto data (" + _toDisplayString(this.selectedSite.siteName) + ")", 1),
                        _hoisted_25
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_26,
                (!_ctx.subscriptionMode)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_27, [
                      _createTextVNode("Base Data"),
                      _hoisted_28
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["row form-group--checkbox", { 'pa--y-2': _ctx.subscriptionMode }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (
                        item.leadFieldName != 'middleName' &&
                        item.leadFieldName != 'lastName' &&
                        item.credit == 0 ||
                        item.leadFieldName == 'email' ||
                        item.leadFieldName == 'city'
                      )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["pa--x-0 pa--bottom-1", {
                        'col-6': item.leadFieldName == 'firstName',
                        'col-3': item.leadFieldName != 'firstName',
                      }])
                          }, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("input", {
                                id: 'field-' + index,
                                type: "checkbox",
                                checked: true,
                                onClick: ($event: any) => (item.value = !item.value),
                                disabled: true
                              }, null, 8, _hoisted_30),
                              _createElementVNode("label", {
                                for: 'field-' + index
                              }, [
                                _createTextVNode(_toDisplayString(item.leadFieldName == "firstName"
                                ? "First Name, Middle Initial & Last Name"
                                : item.displayName) + " ", 1),
                                (!_ctx.subscriptionMode)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (item.leadFieldName != 'email')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, "(Free)"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_33, "($ " + _toDisplayString(_ctx.formatNumber2Decimals(item.credit)) + ")", 1))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_31)
                            ])
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    (!_ctx.subscriptionMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("input", {
                            id: "selectAllFields",
                            type: "checkbox",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAllFields && _ctx.selectAllFields(...args)))
                          }),
                          _hoisted_38
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (
                        item.credit > 0 &&
                        item.leadFieldName != 'email' &&
                        item.leadFieldName != 'city'
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("input", {
                                id: 'field-' + index,
                                type: "checkbox",
                                checked: item.value,
                                onClick: ($event: any) => (item.value = !item.value),
                                disabled: item.disabled
                              }, null, 8, _hoisted_41),
                              _createElementVNode("label", {
                                for: 'field-' + index
                              }, [
                                _createTextVNode(_toDisplayString(item.leadFieldName == "firstName"
                                ? "Full Name"
                                : item.displayName) + " ", 1),
                                (!_ctx.subscriptionMode)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (item.credit > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, "($ " + _toDisplayString(_ctx.formatNumber2Decimals(item.credit)) + ")", 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_44, "(Free)"))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_42)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 2),
                (_ctx.fieldsError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, " Please select at least one parameter "))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-1", {
                'label--active': _ctx.stepper == 2,
              }])
            }, [
              _createElementVNode("div", _hoisted_46, [
                (this.isEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("h3", null, [
                        _createTextVNode("Editing Auto data (" + _toDisplayString(this.selectedSite.siteName) + ")", 1),
                        _hoisted_48
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-field__outline--control__select",
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateOnProjectSelection())),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.siteId) = $event)),
                      style: {"width":"230px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites.data, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: JSON.parse(item.jsonInfo).siteId,
                          disabled: _ctx.isEdit
                        }, _toDisplayString(item.siteName) + " (" + _toDisplayString(JSON.parse(item.jsonInfo).availableLeadCount != null?JSON.parse(item.jsonInfo).availableLeadCount:"NO") + " Leads) ", 9, _hoisted_53))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.siteId]
                    ])
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn--primary",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
                  }, _hoisted_57),
                  _createElementVNode("div", {
                    class: _normalizeClass(["dropdown-menu dropdown-menu__right overflow--hidden", { show: _ctx.showFilters }]),
                    style: {"width":"50px","max-height":"600px","padding":"0.5rem 1rem","z-index":"1000000"}
                  }, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (item, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                                  onChange: ($event: any) => (_ctx.getZipCodes(item)),
                                  id: 'state-' + index
                                }, null, 40, _hoisted_62), [
                                  [_vModelCheckbox, item.selected]
                                ]),
                                _createElementVNode("label", {
                                  for: 'state-' + index
                                }, _toDisplayString(item.text) + " (" + _toDisplayString(_ctx.$filters.numberDisplay(item.value)) + ")", 9, _hoisted_63)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zipCodes, (item, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                                  id: 'zip-' + index
                                }, null, 8, _hoisted_67), [
                                  [_vModelCheckbox, item.selected]
                                ]),
                                _createElementVNode("label", {
                                  for: 'zip-' + index
                                }, _toDisplayString(item.text) + " (" + _toDisplayString(_ctx.$filters.numberDisplay(item.value)) + ")", 9, _hoisted_68)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.googleSearchKeywords) = $event)),
                            placeholder: "Enter up to 10 Google Keywords, separated by commas.",
                            rows: "3",
                            cols: "35",
                            style: {"width":"100%"}
                          }, null, 512), [
                            [_vModelText, _ctx.googleSearchKeywords]
                          ])
                        ])
                      ]),
                      _hoisted_71
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn--primary ma-1 text--size-1",
                        style: {"width":"auto","display":"inline-block","padding-left":"1rem","padding-right":"1rem"},
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                      }, " Apply "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn ma--y-1 text--size-1",
                        style: {"width":"auto","display":"inline-block","padding-left":"1rem","padding-right":"1rem"},
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
                      }, " Clear All ")
                    ])
                  ], 2)
                ])), [
                  [_directive_click_outside, _ctx.clickOutSideFilter]
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-field__outline--control__select",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedFrequency) = $event)),
                      style: {"width":"250px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequencyList, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: item
                        }, _toDisplayString(item), 9, _hoisted_76))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedFrequency]
                    ])
                  ])
                ]),
                (_ctx.selectedFrequency == 'Yearly')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _hoisted_79,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-field__outline--control__select",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedMonthOfYear) = $event)),
                          style: {"width":"250px"}
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MonthOfYearList, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_80))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedMonthOfYear]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedFrequency == 'Yearly'||_ctx.selectedFrequency == 'Monthly'||_ctx.selectedFrequency == 'Bi-Monthly')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-field__outline--control__select",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedDayOfMonth) = $event)),
                          style: {"width":"250px"}
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OayOfMonthList, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_84))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedDayOfMonth]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedFrequency == 'Weekly'||_ctx.selectedFrequency == 'Bi-Weekly')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-field__outline--control__select",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedDayOfWeek) = $event)),
                          style: {"width":"250px"}
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OayOfWeekList, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: item
                            }, _toDisplayString(item), 9, _hoisted_88))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedDayOfWeek]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-field__outline--control__select",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedTimeOfDay) = $event)),
                      style: {"width":"250px"}
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeOfOayList, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: item
                        }, _toDisplayString(item), 9, _hoisted_92))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedTimeOfDay]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_93, [
                  (!_ctx.subscriptionMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isSelectedAllAvailableLeads) = $event)),
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.OnChangeselectedAllAvailableLeadsChange($event)))
                        }, null, 544), [
                          [_vModelCheckbox, _ctx.isSelectedAllAvailableLeads]
                        ]),
                        _hoisted_95,
                        _hoisted_96
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createTextVNode(" Or "),
                _createElementVNode("div", _hoisted_97, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "customLeadNumberId",
                    class: "form-field__outline--control__input",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.customLeadNumber) = $event)),
                    onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.customLeadNumberChangeHandler && _ctx.customLeadNumberChangeHandler(...args))),
                    style: {"width":"400px"}
                  }, null, 544), [
                    [_vModelText, _ctx.customLeadNumber],
                    [_directive_outline]
                  ]),
                  _hoisted_98
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field form-field__outline--active ma--x-1", {
                'form-field__outline--invalid': _ctx.v$.autoLeadValidations.leadsTobeSentEmails.$error,
                }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-field__outline--control__input",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.autoLeadValidations.leadsTobeSentEmails) = $event)),
                    style: {"width":"400px"}
                  }, null, 512), [
                    [_vModelText, _ctx.autoLeadValidations.leadsTobeSentEmails],
                    [_directive_outline]
                  ]),
                  _hoisted_99,
                  _hoisted_100
                ], 2),
                _createElementVNode("div", _hoisted_101, [
                  _createTextVNode(" Filters "),
                  _createElementVNode("span", _hoisted_102, _toDisplayString(this.filterApplied?"States:-"+_ctx.appliedFilterState.join(', ')+" Zip Codes:-"+_ctx.appliedFilterZipCode.join(', '):"No Filter"), 1)
                ])
              ])
            ], 2),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", {
                class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-3", {
                'label--active': _ctx.stepper == 3,
              }])
              }, [
                (this.isEdit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                      _createElementVNode("h3", null, [
                        _createTextVNode("Editing Auto data (" + _toDisplayString(this.selectedSite.siteName) + ")", 1),
                        _hoisted_105
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_106, [
                  _hoisted_107,
                  _createElementVNode("div", _hoisted_108, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllFieldsForDisplay(), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-3 pa--bottom-1 stepper--bar__content--label__info--message__fields"
                      }, [
                        _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(item.displayName) + " ", 1),
                        (!_ctx.subscriptionMode)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (item.displayName !='IP Address' && item.displayName !='City'&& item.displayName !='Zip')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_109, "($ " + _toDisplayString(_ctx.formatNumber2Decimals(item.credits)) + ")", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_110, "(Free)"))
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _createTextVNode(" Base Data (Email Address) "),
                    _createElementVNode("span", _hoisted_112, " $ " + _toDisplayString(_ctx.formatNumber2Decimals(_ctx.emailCreditsForField)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _createTextVNode(" Premium Data "),
                    _createElementVNode("span", _hoisted_114, " $ " + _toDisplayString(_ctx.formatNumber2Decimals(_ctx.selectedPremiumFieldTotalCredits)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPremiumFields(), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-3 pa--bottom-1 stepper--bar__content--label__info--message__fields"
                      }, [
                        _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(item.displayName) + " ", 1),
                        (!_ctx.subscriptionMode)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_116, "($ " + _toDisplayString(_ctx.formatNumber2Decimals(item.credits)) + ")", 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createTextVNode(" Filters "),
                    _createElementVNode("span", _hoisted_118, _toDisplayString(this.filterApplied?"States:-"+_ctx.appliedFilterState.join(', ')+" Zip Codes:-"+_ctx.appliedFilterZipCode.join(', '):"No Filter"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _createTextVNode(" Leads Selected "),
                    _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.isSelectedAllAvailableLeads?"All Available Leads":_ctx.customLeadNumber), 1)
                  ]),
                  _createElementVNode("div", _hoisted_121, [
                    _createTextVNode(" Recipients; "),
                    _createElementVNode("span", _hoisted_122, _toDisplayString(this.autoLeadValidations.leadsTobeSentEmails), 1)
                  ]),
                  _createElementVNode("div", _hoisted_123, [
                    _createTextVNode(" Total Credits (First Charge)"),
                    _hoisted_124,
                    _createElementVNode("span", _hoisted_125, " $ " + _toDisplayString(_ctx.formatNumber2Decimals(_ctx.getTotalCreditsFirstCharge())), 1)
                  ]),
                  (_ctx.insufficentCredits)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                        _createTextVNode(" You don't have enough credits, "),
                        _createElementVNode("a", {
                          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.buyCredits && _ctx.buyCredits(...args)))
                        }, " Buy Credits ")
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_127, [
                    _createTextVNode(" Project "),
                    _createElementVNode("span", _hoisted_128, _toDisplayString(_ctx.selectedSite.siteName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_129, [
                    _createTextVNode(" Frequency "),
                    _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.selectedFrequency), 1)
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _createTextVNode(" Time Of Day "),
                    _createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.selectedTimeOfDay), 1)
                  ]),
                  (_ctx.selectedFrequency === 'Weekly' || _ctx.selectedFrequency === 'Bi-Weekly')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                        _createTextVNode(" Day Of Week "),
                        _createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.selectedDayOfWeek), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedFrequency === 'Yearly' || _ctx.selectedFrequency === 'Monthly'|| _ctx.selectedFrequency === 'Bi-Monthly')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                        _createTextVNode(" Day Of Month "),
                        _createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.selectedDayOfMonth), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedFrequency === 'Yearly' )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                        _createTextVNode(" Month Of Year "),
                        _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.selectedMonthOfYear), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_139, [
              (_ctx.fieldsError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_140, _toDisplayString(_ctx.fieldsMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn--secontary",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, " Cancel "),
              (_ctx.stepper != 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "btn btn--secontary",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
                  }, " Back "))
                : _createCommentVNode("", true),
              (_ctx.stepper == 1 ||_ctx.stepper == 2  )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "btn btn--primary",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.continueStep && _ctx.continueStep(...args))),
                    disabled: _ctx.isContinueDisabled()
                  }, " Continue ", 8, _hoisted_141))
                : (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    type: "button",
                    class: "btn btn--primary",
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.doSubmitAutoLead && _ctx.doSubmitAutoLead(...args)))
                  }, " Submit "))
            ])
          ])
        ])
      ])
    ])
  ]))
}